__webpack_require__.p = "/new-translations-check/referrals/";